<template>
    <div class="textarea--wrapper">
        <div class="checkbox--frame">
            <label class="checkbox-container"> I agree to let BOHEMIA INTERACTIVE a.s. inform me about any suitable
                positions in the
                future.
                <input type="checkbox" id="checkbox" v-model="checked">
                <span class="checkmark"></span>
            </label>
        </div>
        <div class="paragraph--frame">
            <p class="paragraph">
                I hereby give my consent to processing of my personal data. The consent is granted to BOHEMIA
                INTERACTIVE a.s., ID No: 272 18 864, having its registered office at Stříbrná Lhota 747, Mníšek pod Brdy
                252 10 as the data controller to administer, process and keep my personal data contained in my CV and my
                email address, name and telephone number for the purposes of record keeping of job applicants and
                eventual offering a job to such applicants. Consent is given for the term of 2 years from the date
                consent is given. I declare that the consent is given voluntarily and acknowledge that it may be
                withdrawn at any time.
            </p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TextArea",
        data() {
            return {
                checked: false
            }
        },
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            checked() {
                this.$emit('input', this.checked)
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";

    .textarea--wrapper {
        border: 1px solid #444444;
        border-radius: 4px;
    }

    .checkbox--frame {
        padding: 2em;

    }

    .paragraph--frame {
        border-top: 1px solid #444444;
        padding: 2em;
    }

    .checkbox-container {
        display: block;
        position: relative;
        padding-left: 35px;
        padding-top: 2px;
        cursor: pointer;
        font-size: 18px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #fff;
        border-radius: 2px;
        border: 2px solid #1a1a1a;
    }

    /* On mouse-over, add a grey background color */
    .checkbox-container:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .checkbox-container input:checked ~ .checkmark {
        background-color: #1a1a1a;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .checkbox-container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .checkbox-container .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }


</style>


// WEBPACK FOOTER //
// src/components/common/GDPR.vue